<mat-form-field class="field-width70" appearance="fill">
    <mat-label>{{ 'TRANSLATOR.ENTITY' | translate }}</mat-label>
    <input
        type="text"
        required
        placeholder="Entidade...."
        aria-label="Entity"
        matInput
        [formControl]="myControl"
        [matAutocomplete]="auto" />
    <mat-autocomplete [displayWith]="displayContextName" autoActiveFirstOption #auto="matAutocomplete">
        <mat-option
            [disabled]="_loaderService.isLoading | async"
            (click)="onChangeEntity(entity)"
            *ngFor="let entity of filterEntities | async"
            [value]="entity.description">
            <span>{{ entity.description }} </span>
        </mat-option>
    </mat-autocomplete>
</mat-form-field>
